import React from 'react';
import { safeLocalStorage, safeSessionStorage } from '../utils/safeStorage';

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Error fatal en el frontend:', error, info);
  }

  handleRetry = () => {
    window.location.reload();
  };

  handleReset = () => {
    safeLocalStorage.removeItem('token');
    safeLocalStorage.removeItem('user');
    safeSessionStorage.removeItem('agua-andre-assistant-state-v2');
    safeSessionStorage.removeItem('agua-andre-assistant-history');
    window.location.assign('/');
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <main className="min-h-screen bg-background-light px-4 py-10 text-slate-800 dark:bg-background-dark dark:text-slate-100">
        <section className="mx-auto flex min-h-[80vh] max-w-xl flex-col items-center justify-center text-center">
          <div className="mb-5 flex size-14 items-center justify-center rounded-full bg-primary/10 text-primary">
            <span className="material-symbols-outlined text-3xl">warning</span>
          </div>
          <h1 className="text-2xl font-bold">No pudimos cargar el portal</h1>
          <p className="mt-3 text-sm leading-6 text-slate-600 dark:text-slate-300">
            Puede haber una version vieja guardada en el navegador o datos de sesion danados.
          </p>
          <div className="mt-6 flex w-full flex-col gap-3 sm:flex-row sm:justify-center">
            <button
              type="button"
              onClick={this.handleRetry}
              className="h-11 rounded-lg bg-primary px-5 text-sm font-bold text-white transition-colors hover:bg-primary/90"
            >
              Reintentar
            </button>
            <button
              type="button"
              onClick={this.handleReset}
              className="h-11 rounded-lg border border-slate-300 bg-white px-5 text-sm font-bold text-slate-700 transition-colors hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800"
            >
              Limpiar sesion
            </button>
          </div>
        </section>
      </main>
    );
  }
}

export default AppErrorBoundary;
